import { Component, Input, OnInit, ChangeDetectionStrategy, ViewChild, ChangeDetectorRef } from '@angular/core';
import { MediaTeaserBoxInterface } from './shared/interfaces/media-teaser-box.interface';

@Component({
    selector: 'da-media-teaser-box',
    templateUrl: './media-teaser-box.component.html',
    styleUrls: ['./media-teaser-box.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class MediaTeaserBoxComponent {
    @Input() data: MediaTeaserBoxInterface = {
        _type: 'MediaTeaserBox',
        mediaAlignment: 'right',
        mediaType: 'image',
        image: 'any',
        headline: '',
        copytext: '',
        button: ''
    };
    @ViewChild('videoComponent') private _videoComponent;
    public videoImageAspectRatios = [
        {
            breakpoint: 360,
            width: 480,
            height: 320,
            akamaiImage: null
        },
        {
            breakpoint: 960,
            width: 578,
            height: 385,
            akamaiImage: null
        },
        {
            breakpoint: 1120,
            width: 768,
            height: 512,
            akamaiImage: null
        }
    ];
    constructor() {}

    public startVideo(): void {
        if (this._videoComponent != null) {
            this._videoComponent.playVideo();
        }
    }

    public getImageUrl(): string {
        const _target =
            this.data.mediaType === 'image'
                ? this.data.image
                    ? this.data.image.imageUrl
                    : ''
                : this.data.video
                ? this.data.video.imageUrl
                : '';
        return _target == null ? '' : _target;
    }
}
